import { render, staticRenderFns } from "./AtencionDocAs400.vue?vue&type=template&id=608ced21"
import script from "./AtencionDocAs400.vue?vue&type=script&lang=js"
export * from "./AtencionDocAs400.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports